<template>
  <a-button type="text" class="button button__info" @click="openDrawer">
    <div v-if="text" class="button__contact">
      {{ text }}
    </div>
    <div v-else class="button__icon">
      <a-tooltip v-if="itemScope==='tab_email'" color="white" placement="bottomLeft">
        <InfoCircleOutlined />
        <template #title>
          <span class="title-tooltip">
            Gestiona de manera eficiente todas las comunicaciones de correo entrantes y salientes vinculadas a tus campañas.
            Conoce más haciendo
            <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">click aquí</a>.
          </span>
        </template>
      </a-tooltip>
      <a-tooltip v-else-if="itemScope==='menu_workspace'" color="white" placement="bottomLeft">
        <InfoCircleOutlined />
        <template #title>
          <span class="title-tooltip">
            Visualiza tickets, interactúa con contactos por canales y gestiona su información en tiempo real. Haz clic para conocer más.
          </span>
        </template>
      </a-tooltip>
      <InfoCircleOutlined v-else/>
    </div>
  </a-button>

  <a-drawer
    v-model:visible="visible"
    class="info-drawer"
    placement="right"
    :closable="false"
    :width="420"
  >
    <template #title>
      <header>
        <span class="title">Centro de ayuda</span>

        <a-button type="text" class="button button__close" @click="visible = false">
          <CloseOutlined class="icon" />
        </a-button>
      </header>
    </template>

    <InfoDrawerContent :scope="itemScope" :initial-item-orders="initialItemOrders" />

    <template #footer>
      <footer>
        <a-button class="support" :href="supportUrl" target="_blank">
          Ir a Soporte
          <IconExternalLink active />
        </a-button>
        <a-button @click="visible = false"> Cerrar </a-button>
      </footer>
    </template>
  </a-drawer>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from "vue";
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons-vue";
import { supportUrl } from "@/app/common/components/organisms/TheSidebar/items";
import InfoDrawerContent from "../molecules/InfoDrawerContent.vue";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";
import EventBus from "@/app/shared/utils/eventBus";
import { OPEN_HELP_CENTER_EVENT } from "@/app/entities/utils/helpCenter";
import type { OpenHelpCenterPayload } from "@/app/entities/utils/helpCenter";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/correo/buzon-correo`;

const props = defineProps<{
  itemScope: string;
  text: {
    type: string;
    required: false;
  };
}>();

const visible = ref(false);
const initialItemOrders = ref<number[]>([]);

const openDrawer = () => {
  initialItemOrders.value = [];
  visible.value = true;
};

const openHelpCenter = ({ scope, itemOrders = [] }: OpenHelpCenterPayload) => {
  if (scope !== props.itemScope) return;

  initialItemOrders.value = [...itemOrders];
  visible.value = true;
};

EventBus.on(OPEN_HELP_CENTER_EVENT, openHelpCenter);

onBeforeUnmount(() => {
  EventBus.off(OPEN_HELP_CENTER_EVENT, openHelpCenter);
});
</script>

<style scoped lang="sass">
.button
  padding: 0

  &__info
    height: 22px
    :hover
      color: $gray-13
  &__icon
    margin-left: 8px

  &__close
    width: 32px
  &__contact
    color: #1890FF

.icon
  font-size: $font-medium

header
  display: flex
  justify-content: space-between
  align-items: center
  .title
    font-size: 24px

footer
  display: flex
  justify-content: space-between
  width: 100%
  .support
    border: none
    box-shadow: none
    color: $blue-6
    display: inline-flex
    align-items: center
    gap: 8px

.button__info
  background-color: transparent !important

.title-tooltip
  color: $gray-9
</style>

<style>
.info-drawer .ant-drawer-header,
.info-drawer .ant-drawer-body {
  padding: 10px 20px !important;
}
</style>
